// extracted by mini-css-extract-plugin
module.exports = {"layoutGrid":"layout-grid_layoutGrid__lo7JX"};